<template>
  <div class="text-center mt-2">
    <a class="white--text caption" @click="dialog = true">Mot de passe oublié ? Première connexion ?</a>

    <v-dialog v-model="dialog" max-width="420">
      <v-card>
        <v-card-title>Recevoir un lien</v-card-title>
        <v-card-text v-if="sent">
          Si un compte correspond à cet identifiant, un lien pour choisir votre mot de passe vient de lui être envoyé par e-mail.
          Il ne fonctionne qu'une fois et expire dans 1 heure.
        </v-card-text>
        <v-card-text v-else>
          <v-text-field
            v-model="login"
            label="Identifiant (adresse e-mail)"
            autocomplete="username"
            @keyup.enter="onSend"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{ sent ? 'Fermer' : 'Annuler' }}</v-btn>
          <v-btn v-if="!sent" color="primary" :loading="isSending" :disabled="!login" @click="onSend">Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Plus de mot de passe initial : première connexion et oubli passent par un lien à usage unique (SEC-24)
export default {
  name: 'AForgotPassword',
  data: () => ({
    dialog: false,
    login: '',
    sent: false,
    isSending: false
  }),
  methods: {
    onSend: function() {
      if (!this.login) return
      this.isSending = true
      // La réponse est la même que le compte existe ou non
      this.$http.post('forgetpassword', { user: this.login.trim() })
        .catch(error => console.log(error))
        .finally(() => {
          this.isSending = false
          this.sent = true
        })
    },
    close: function() {
      this.dialog = false
      this.sent = false
      this.login = ''
    }
  }
}
</script>
